// import React, { useEffect, useState } from "react";

// const CountdownTimer = ({ expiryTime }: { expiryTime: number }) => {
//   const calculateTimeLeft = () => {
//     const now = Date.now();
//     const diff = expiryTime - now;

//     if (diff <= 0) {
//       return { hours: 0, minutes: 0, seconds: 0 };
//     }

//     const hours = Math.floor(diff / (1000 * 60 * 60));
//     const minutes = Math.floor((diff / (1000 * 60)) % 60);
//     const seconds = Math.floor((diff / 1000) % 60);

//     return { hours, minutes, seconds };
//   };

//   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setTimeLeft(calculateTimeLeft());
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [expiryTime]);

//   return (
//     <div style={{ display: "flex", gap: "12px" }}>
//       <div>
//         <span style={{ background: "rgba(255, 255, 255, 1)" }}>
//           {timeLeft.hours}
//         </span>{" "}
//         <small>Hours</small>
//       </div>
//       <div>
//         <span style={{ background: "rgba(255, 255, 255, 1)" }}>
//           {timeLeft.minutes}
//         </span>{" "}
//         <small>Minutes</small>
//       </div>
//       <div>
//         <span style={{ background: "rgba(255, 255, 255, 1)" }}>
//           {timeLeft.seconds}
//         </span>{" "}
//         <small>Seconds</small>
//       </div>
//     </div>
//   );
// };

// export default CountdownTimer;
import React, { useEffect, useState } from "react";

const CountdownTimer = () => {
  // 15 minutes from now
  const expiryTime = Date.now() + 15 * 60 * 1000;

  const calculateTimeLeft = (endTime: number) => {
    const now = Date.now();
    const diff = endTime - now;

    if (diff <= 0) {
      return { minutes: 0, seconds: 0 };
    }

    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return { minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(expiryTime));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(expiryTime));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ display: "flex", gap: "12px" }}>
      <div>
        <span>{timeLeft.minutes}</span> <small>Minutes</small>
      </div>
      <div>
        <span>{timeLeft.seconds}</span> <small>Seconds</small>
      </div>
    </div>
  );
};

export default CountdownTimer;
